//import * as e from './e.json';
import e from './e.json';
/*
import {
  ht,
  hfDTM,
} from 'lib';
*/
import * as ht from './_ht';
import * as hfDTM from './_hfDTM';

//export const appName = 'ufss';
export const appName = '部屋予約システム';

export const appz = e.appz;

export const dmn = 'f-supportsys2.com';

export const dsnz = {
  nDwrW: 0,
  nFtrH: 0,
  nHdrH: 0,
  nMdlH: 60,
  nMdlW: 30,
  nSdrW: 10,
};

/* ihv へ移動
export const mailz = { // ihv.mailz と統合用
  bcc: e.mailz.bcc,
  lz: {
    grtMsg1: (_dz: ht.dz) => {
return (
`団体番号：${_dz.i18rz?.i18rab100s ?? ''}
${_dz.i18rz?._pfx ?? ''}　様

-------------------------------------------------

エントリー抽選結果をご連絡致します。

下記エントリーが当選し、正式な予約として登録致しました。

<<< エントリー内容 >>>　　(ID：${_dz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${hfDTM.f(_dz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${_dz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${_dz.i1zrz?.i1zra1200s ?? ''}

-------------------------------------------------
${_dz.stgz?.S08050111 ?? ''}


${_dz.stgz?.S01050111 ?? ''}
`
)},
    grtMsg2: (_dz: ht.dz) => {
return (
`団体番号：${_dz.i18rz?.i18rab100s ?? ''}
${_dz.i18rz?._pfx ?? ''}　様

-------------------------------------------------

エントリー抽選結果をご連絡致します。

下記エントリーが当選し、正式な予約として登録致しました。

なお、お申し込みいただいた備品・駐車場の一部は、
抽選の結果、ご利用対象から除外しておりますので、
ご了承ください。

<<< エントリー内容 >>>　　(ID：${_dz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${hfDTM.f(_dz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${_dz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${_dz.i1zrz?.i1zra1200s ?? ''}

-------------------------------------------------
${_dz.stgz?.S08050111 ?? ''}


${_dz.stgz?.S01050111 ?? ''}
`
)},
    grtMsg3: (_dz: ht.dz) => {
return (
`団体番号：${_dz.i18rz?.i18rab100s ?? ''}
${_dz.i18rz?._pfx ?? ''}　様

-------------------------------------------------

エントリー抽選結果をご連絡致します。

下記エントリーについて抽選の結果、
残念ながら今回はご期待に沿えない結果となりました。

<<< エントリー内容 >>>　　(ID：${_dz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${hfDTM.f(_dz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${_dz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${_dz.i1zrz?.i1zra1200s ?? ''}

-------------------------------------------------
${_dz.stgz?.S08050121 ?? ''}


${_dz.stgz?.S01050111 ?? ''}
`
)},
    grtMailArsAdd: (pz: {
      i18rz: ht.dz,
    }) => { // メールアドレスの登録
      return {
        sjt:
`メールアドレス登録のご連絡`,
        msg:
`
この度は、メールアドレスのご登録をありがとうございます。
登録されたアドレスをご連絡します。

<<< 登録されたメールアドレス >>>

${pz.i18rz.i18ra4110s ? `　主　： ${pz.i18rz.i18ra4110s}` : ''}
${pz.i18rz.i18ra4210s ? `　副１： ${pz.i18rz.i18ra4210s}` : ''}
${pz.i18rz.i18ra4310s ? `　副２： ${pz.i18rz.i18ra4310s}` : ''}
`,
      }
    },

    grtMailRsvAdd: (pz: { // reserve add
      i1zrz: ht.dz,
    }) => {
      return {
        sjt:
`ご予約を受け付けました（ID：${pz.i1zrz?._icn ?? ''}）`,
        msg: 
`
ご利用いただきまして誠にありがとうございます。

下記ご予約を受け付けましたので、ご連絡いたします。
なお、本ご予約を変更する場合は、キャンセルした後、改めてご予約ください。

<<< ご予約内容 >>>　　(ID：${pz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${hfDTM.f(pz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${pz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${pz.i1zrz?.i1zra1200s ?? ''}
${pz.i1zrz?.i1zra8100s ? `■ 伝達事項　 ： ${pz.i1zrz?.i1zra8100s}` : ''}
`
}},

    grtMailRsvCcl: (pz: { // reserve cancel
      i1zrz: ht.dz,
    }) => {
      return {
        sjt:
`ご予約のキャンセルを受け付けました（ID：${pz.i1zrz?._icn ?? ''}）`,
        msg: 
`
ご利用いただきまして誠にありがとうございます。

下記ご予約のキャンセルを受け付けましたので、ご連絡いたします。

<<< ご予約内容 >>>　　(ID：${pz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${hfDTM.f(pz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${pz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${pz.i1zrz?.i1zra1200s ?? ''}
${pz.i1zrz?.i1zra8100s ? `■ 伝達事項　 ： ${pz.i1zrz?.i1zra8100s}` : ''}
`
    }},

    grtMailAlyAdd: (pz: { // Apply add
      i1zrz: ht.dz,
    }) => {
      return {
        sjt:
`エントリーを受け付けました（ID：${pz.i1zrz?._icn ?? ''}）`,
        msg: 
`
ご利用いただきまして誠にありがとうございます。

下記エントリーを受け付けましたので、ご連絡いたします。
なお、本エントリーを変更する場合は、キャンセルした後、改めてご予約ください。

<<< エントリー内容 >>>　　(ID：${pz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${hfDTM.f(pz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${pz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${pz.i1zrz?.i1zra1200s ?? ''}
${pz.i1zrz?.i1zra8100s ? `■ 伝達事項　 ： ${pz.i1zrz?.i1zra8100s}` : ''}
`
}},

    grtMailAlyCcl: (pz: { // reserve cancel
      i1zrz: ht.dz,
    }) => {
      return {
        sjt:
`エントリーのキャンセルを受け付けました（ID：${pz.i1zrz?._icn ?? ''}）`,
        msg: 
`
ご利用いただきまして誠にありがとうございます。

下記エントリーのキャンセルを受け付けましたので、ご連絡いたします。

<<< エントリー内容 >>>　　(ID：${pz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${hfDTM.f(pz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${pz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${pz.i1zrz?.i1zra1200s ?? ''}
${pz.i1zrz?.i1zra8100s ? `■ 伝達事項　 ： ${pz.i1zrz?.i1zra8100s}` : ''}
`
    }},

    grtMailSendPwd: (pz: { // send password
      i18rz: ht.dz,
    }) => {
      return {
        sjt:
`パスワードをお知らせします`,
        msg: 
`
ご利用いただきまして誠にありがとうございます。

ログイン画面において別途ご入力いただいたログインIDのパスワードは以下のとおりです。

<<< 別途ご入力いただいたログインIDのパスワード >>>

${pz.i18rz.i18ra4130s}
`
    }},

  }
}
*/

export const nCntPerPageMax = 100;

export const nI1z1CntMax = 4;

/*
export const otrz = {
  key: -999,
  pfx: 'その他1時間',
  _fst: -999,
  _pfx: 'その他1時間', // i1z1a2200s の設定に必要
  cldz: {},
}; // その他１時間
*/

export const icnAmn = '_SystemAdmin20230118_';

export const srtz = e.srtz;

export const sttz = {
  rs: [
    { key: 999, pfx: 'すべて' },
    { key: 990, pfx: '仮予約＋本予約' },
    { key: 80, pfx: '仮予約' },
    { key: 90, pfx: '本予約' },
    { key: 70, pfx: '仮押' },
    { key: 26, pfx: '返金なしキャンセル' },
    { key: 24, pfx: '返金ありキャンセル' },
    { key: 22, pfx: '仮予約キャンセル' },
  ],
  es: [
    { key: 999, pfx: 'すべて' },
    { key: 60, pfx: '未エントリー' },
    { key: 70, pfx: 'エントリー済' },
    { key: 90, pfx: '当選' },
    { key: 80, pfx: '落選' },
    { key: 20, pfx: 'キャンセル済' },
  ],
  ls: [
    { key: 999, pfx: 'すべて' },
    { key:  -1, pfx: '未抽選' },
    { key:   1, pfx: '抽選済' },
  ]
};

/*
export const urlz = {
  imn: 'https://cgi.city.yokohama.lg.jp/shimin/chikucenter/center.php?d=c00100',
}
*/